export const dropList = {
    titles: {
        dropDownList: 'Listas desplegables',
        newDropList: 'Nueva lista desplegable',
        editDropList: 'Editar lista desplegable',
        catalogValues: 'Valores del catálogo'
    },
    tags: {
        searchList: 'Buscar',
        listName: 'Nombre de la lista',
        values: '# valores',
        relations: '# relaciones'
    },
    inputs: {
        errors:{
            nameRequeried: 'El nombre de la lista es obligatorio',
            minLength: 'El campo debe contener un minimo de {{min}} caracteres'
        },
        nameDropDownLists: 'Nombre de la lista desplegable',
        valueDropDownList: 'Valor de la lista'
    },
    helperInputs: {
        nameDropDownLists: 'Ingrese el nombre de la lista',
        valueDropDownList: 'Ingrese el valor de la lista'
    },
    buttons: {

    },
    modal: {
        titles: {
            confirmation: 'Confirmación'
        },
        descriptions: {
            cancelCreate: '¿Está seguro que desea cancelar la creación?<br/>Se perderán los cambios que no hayan sido guardados.',
            cancelEdition: '¿Está seguro que desea cancelar la edición?<br/>Se perderán los cambios que no hayan sido guardados.',
            confirmDelete: '¿Está seguro de que quiere eliminar esta lista desplegable?'
        }
    },
    snackBar: {
        success: {
            deleteList: 'La lista fue eliminada exitosamente.',
            createList: 'La lista se creó correctamente.',
            editList: 'La lista se actualizó correctamente.'
        },
        error: {
            deleteList: 'La lista tiene relaciones activas y no puede eliminarse.',
            createList: 'No fue posible crear la lista porque el nombre ingresado ya está en uso.',
            editList: 'La lista se actualizó correctamente.'
        }
    }
}